import axios from "axios";
import get from "lodash/get";
import * as Sentry from "@sentry/browser";
import config from '@/config';
import storage from "../storage";

const request = axios.create({
  baseURL: config.API_ROOT,
});

request.defaults.params = {};
request.defaults.params["_f"] = "json";
request.defaults.headers.common["Accept"] = "application/json";
request.defaults.headers.common["Cache-Control"] = "no-cache";

let store = null;

const subscribe = (appStore) => {
  store = appStore;
  const state = store.getState();
  request.defaults.params["_l"] = state.system.currentLangCode;
  request.defaults.params["_c"] = state.system.currentCountryCode;
};

request.interceptors.request.use((requestConfig) => {
  const state = store && store.getState();
  const token = get(state, "auth.token") || storage.get("token");

  if (token) {
    requestConfig.headers.set("Authorization", `Bearer ${token}`);
  }

  return requestConfig;
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedError) {
      Sentry.withScope((scope) => {
        scope.setExtra("Error URL", get(error, "config.url"));
        scope.setExtra("Error Message", get(error, "response.data.message"));
        scope.setExtra(
          "Error Status",
          `${get(error, "response.status")} - ${get(
            error,
            "response.statusText"
          )}`
        );
        scope.setExtra("Error Full", error);
        Sentry.captureException(error);
      });
    }

    return Promise.reject(error);
  }
);

export default {
  request,
  subscribe,
};
